import { render, staticRenderFns } from "./BoundingBox.vue?vue&type=template&id=7c49b9e9&scoped=true&"
import script from "./BoundingBox.vue?vue&type=script&lang=js&"
export * from "./BoundingBox.vue?vue&type=script&lang=js&"
import style0 from "./BoundingBox.vue?vue&type=style&index=0&id=7c49b9e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c49b9e9",
  null
  
)

export default component.exports